import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paragraph, Separator } from '@fs/zion-ui'
import Tip from '../../../tip/Tip'

export default function HighlightsTipsOld() {
  const [t] = useTranslation()

  return (
    <Tip
      useOverline={false}
      primaryText={t('editHighlight.highlightTips.item1PrimaryText', 'How to add and remove highlights?')}
      listPrimaryText={
        <>
          <span>
            <b>{t('editHighlight.highlightTips.item1Title', '1. What is in Essential Information?')}</b>
          </span>
          <Separator size="xxs" />
          <Paragraph size="sm">
            {t(
              'editHighlight.highlightTips.item1Content',
              'To add a highlight, hover over the correct name on the image. If a blue highlight appears, select it and then attach.'
            )}
          </Paragraph>
          <Separator size="xxs" />
          <Paragraph size="sm">
            {t(
              'editHighlight.highlightTips.item1SubContent',
              'To remove a highlight, hover over an existing yellow highlight and select it and then detach.'
            )}
          </Paragraph>
          <Separator size="sm" />
          <span>
            <b>{t('editHighlight.highlightTips.item1Title2', '2. What if I don’t see a blue highlight?')}</b>
          </span>
          <Separator size="xxs" />
          <Paragraph size="sm">
            {t('editHighlight.highlightTips.item1Content2', 'If no blue highlight appears, you will create a new one.')}
          </Paragraph>
        </>
      }
    />
  )
}
